import React from 'react'

const FeaturesPage = () => {
  return (
    <div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Features | Lusid</title>
  <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;800&display=swap" rel="stylesheet">
  <style>
    :root {
      --blue-main: #0a66c2;
      --blue-dark: #004182;
      --blue-muted: #56687a;
      --blue-light: #dce6f1;
      --grey-main: #38434f;
      --grey-light: #e9e5df;
      --off-white: #fdfaf5;
      --white: #ffffff;
      --accent-green: #00c49a;
    }
    html, body {
      margin: 0;
      padding: 0;
      background: var(--white);
      color: var(--grey-main);
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
      // font-size: 18px;
      line-height: 1.6;
    }
    header {
      width: 100%;
      background: var(--white);
      position: sticky;
      top: 0;
      z-index: 100;
      border-bottom: 1px solid var(--grey-light);
    }
    .nav-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 32px;
    }
    .logo img {
      height: 40px;
      display: block;
    }
    nav {
      display: flex;
      gap: 32px;
      align-items: center;
    }
    nav a {
      text-decoration: none;
      color: var(--grey-main);
      font-weight: 500;
      font-size: 1rem;
      padding: 6px 0;
      transition: color 0.15s;
    }
    nav a:hover {
      color: var(--blue-main);
    }
    .cta-nav {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 20px;
      padding: 8px 22px;
      font-weight: 600;
      font-size: 1rem;
      margin-left: 12px;
      text-decoration: none;
      transition: background 0.15s;
      border: none;
      cursor: pointer;
    }
    .cta-nav:hover {
      background: var(--blue-dark);
    }
    .hero {
      background: var(--white);
      text-align: center;
      padding: 90px 20px 40px 20px;
      margin-bottom: 20px;
    }
    .hero h1 {
      font-size: 2.8rem;
      font-weight: 800;
      color: var(--blue-main);
      margin-bottom: 18px;
      letter-spacing: -1px;
    }
    .hero p {
      font-size: 1.25rem;
      color: var(--grey-main);
      margin-bottom: 0;
      max-width: 650px;
      margin-left: auto;
      margin-right: auto;
    }
    .section {
      max-width: 1100px;
      margin: 0 auto 60px auto;
      padding: 0 24px;
    }
    .section-title {
      font-size: 2rem;
      font-weight: 700;
      color: var(--blue-main);
      text-align: center;
      margin-bottom: 30px;
      letter-spacing: -0.5px;
    }
    .features-row {
      display: flex;
      flex-wrap: wrap;
      gap: 40px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .feature-block {
      background: var(--blue-light);
      border-radius: 18px;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
      padding: 32px 24px;
      min-width: 260px;
      max-width: 340px;
      flex: 1 1 260px;
      text-align: left;
      margin-bottom: 10px;
      color: var(--grey-main);
      position: relative;
    }
    .feature-block h3 {
      color: var(--blue-main);
      font-size: 1.15em;
      margin-bottom: 10px;
      font-weight: 700;
    }
    .feature-block ul {
      margin: 0 0 0 18px;
      padding: 0;
      color: var(--blue-dark);
      font-size: 1em;
    }
    .feature-block li {
      margin-bottom: 8px;
    }
    .feature-icon {
      font-size: 2em;
      position: absolute;
      right: 24px;
      top: 24px;
      opacity: 0.8;
      pointer-events: none;
    }
    .solutions-row {
      display: flex;
      flex-wrap: wrap;
      gap: 36px;
      justify-content: center;
      margin-bottom: 40px;
    }
    .solution-block {
      background: var(--off-white);
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
      padding: 28px 22px;
      min-width: 220px;
      max-width: 340px;
      flex: 1 1 220px;
      text-align: center;
      color: var(--blue-dark);
      font-size: 1.08em;
      font-weight: 600;
    }
    .solution-block h4 {
      color: var(--blue-main);
      margin-bottom: 10px;
      font-size: 1.13em;
      font-weight: 700;
    }
    .solution-block p {
      font-size: 1em;
      color: var(--grey-main);
      font-weight: 400;
      margin-bottom: 0;
    }
    .cta-section {
      background: var(--white);
      text-align: center;
      padding: 70px 0 70px 0;
    }
    .cta-section h2 {
      color: var(--blue-main);
      font-size: 2rem;
      margin-bottom: 18px;
      font-weight: 700;
    }
    .cta-section .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 24px;
      padding: 16px 46px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .cta-section .cta-main:hover {
      background: var(--blue-dark);
    }
    footer {
      background: var(--off-white);
      padding: 40px 0;
      text-align: center;
      font-size: 1rem;
      color: var(--blue-muted);
      border-top: 1px solid var(--blue-light);
      letter-spacing: 0.1px;
    }
    @media (max-width: 1000px) {
      .features-row, .solutions-row { flex-direction: column; align-items: center; }
      .section { padding: 0 8px; }
    }
  </style>
</head>
<body>

  <section class="hero">
    <h1>Features & Capabilities</h1>
    <p>
      Lusid empowers your business with intelligent automation, global payments, and frictionless workflows. Discover our most powerful features and solutions.
    </p>
  </section>

  <section class="section" id="lusid-capabilities">
    <div class="section-title">Core Capabilities</div>
    <div class="features-row">
      <div class="feature-block">
        <span class="feature-icon">🤖</span>
        <h3>AI-Driven Automation</h3>
        <ul>
          <li>Automated invoice capture</li>
          <li>AI-powered data extraction & coding</li>
          <li>Vendor & item matching</li>
          <li>Smart approval workflows</li>
        </ul>
      </div>
      <div class="feature-block">
        <span class="feature-icon">🌍</span>
        <h3>Global Payments</h3>
        <ul>
          <li>Pay & get paid in 180+ countries</li>
          <li>35 currencies supported</li>
          <li>Competitive FX rates</li>
          <li>Multiple payment delivery speeds</li>
        </ul>
      </div>
      <div class="feature-block">
        <span class="feature-icon">🔗</span>
        <h3>Seamless Integrations</h3>
        <ul>
          <li>QuickBooks Desktop, QuickBooks Online, and Xero</li>
          <li>Bi-directional sync</li>
          <li>Instant reconciliation</li>
          <li>Open API for custom solutions</li>
        </ul>
      </div>
      <div class="feature-block">
        <span class="feature-icon">🔒</span>
        <h3>Bank-Grade Security</h3>
        <ul>
          <li>Encryption in transit and at rest</li>
          <li>Multi-factor authentication</li>
          <li>Audit trails & compliance</li>
          <li>Role-based access controls</li>
        </ul>
      </div>
    </div>
  </section>

  <section class="section" id="lusid-solutions">
    <div class="section-title">Solutions for Every Business</div>
    <div class="solutions-row">
      <div class="solution-block">
        <h4>Accounts Payable Automation</h4>
        <p>
          Capture, approve, and pay bills globally. Reduce manual work, eliminate errors, and gain real-time control over your AP process.
        </p>
      </div>
      <div class="solution-block">
        <h4>Accounts Receivable Automation</h4>
        <p>
          Create and send invoices in seconds, accept payments in any currency, and accelerate your cash flow with automated reminders and reconciliation.
        </p>
      </div>
      <div class="solution-block">
        <h4>Pay by Business handle</h4>
        <p>
No more juggling account numbers or routing information. This feature reduces errors, saves time, and ensures your payments reach the right destination quickly and securely.
        </p>
      </div>
      <div class="solution-block">
        <h4>Precision AI Data Capture </h4>
        <p>
          Say goodbye to manual data entry. Our advanced AI-powered OCR extracts details from invoices, receipts, and statements—then syncs them to your accounting system.
        </p>
      </div>
      <div class="solution-block">
        <h4>AI Categorization</h4>
        <p>
          Let AI handle the tedious work. Our intelligent engine reviews and categorizes every transaction automatically—saving you hours and eliminating the risk of human error.
        </p>
      </div>
      <div class="solution-block">
        <h4>AI That Learns</h4>
        <p>
          Powered by machine learning, the AI becomes increasingly accurate over time—handling more of your accounting tasks with greater confidence and precision.
        </p>
      </div>
<div class="solution-block">
        <h4>Industry-Specific Extensions</h4>
        <p>
          Tailored modules for hospitality, logistics, construction, healthcare and more. Get features and workflows built for your industry.
        </p>
      </div>
      <div class="solution-block">
        <h4>Custom Workflows & Reporting</h4>
        <p>
          Build custom approval flows, automate recurring payments, and generate actionable insights with advanced reporting.
        </p>
      </div>
      <div class="solution-block">
        <h4>Real-Time Books, Real-Time Decisions</h4>
        <p>
          With AI Agents updating your books in real time, you’ll always have up-to-date financials—empowering faster insights, and better advisory support.

      </div>
    </div>
  </section>

  <section class="cta-section" id="features-cta">
    <h2>Ready to streamline your finance operations?</h2>
    <button class="cta-main" onclick="window.location='/contact-us'">Contact Us</button>
  </section>

</body>
</html>
` }} />
  )
}

export default FeaturesPage;